import type { ImpactType, LanguageType, SocialMediaType } from '@/api/interfaces'

export const IMPACT_TYPE_PIN_COLOR_MAP: Record<ImpactType, string> = {
  carbon: '#FFB339',
  trees: '#49E2A7',
  plastic: '#1FAEF0',
  kelp: '#49A29F',
  water: '#6074FF',
  bees: '#8F6C11',
}

export const IMPACT_TYPE_MAP_PIN_COLOR_MAP: Record<ImpactType, string> = {
  carbon: '#C97E03',
  trees: '#1A975B',
  plastic: '#2C9ED4',
  kelp: '#33A39F',
  water: '#6572ED',
  bees: '#8F6C11',
}

export const IMPACT_TYPE_INACTIVE_PIN_COLOR_MAP: Record<ImpactType, string> = {
  carbon: '#FFE7C0',
  trees: '#CBEFE1',
  plastic: '#9CD2EB',
  kelp: '#9BD3D3',
  water: '#93B1FF',
  bees: '#EACA78',
}

export interface Constants {
  socialMediaLinks: Record<SocialMediaType, string>
  languages: Record<LanguageType, string>
}

const socialMediaLinks: Record<SocialMediaType, string> = {
  website: 'https://www.getgreenspark.com',
  facebook: 'https://www.facebook.com/get.greenspark',
  instagram: 'https://www.instagram.com/get_greenspark',
  linkedin: 'https://www.linkedin.com/company/get-greenspark',
  twitter: 'https://twitter.com/get_greenspark',
  tiktok: 'https://www.tiktok.com/@get_greenspark',
  youtube: 'https://www.youtube.com/@get_greenspark',
}

const languages: Record<LanguageType, string> = {
  en: 'English',
  de: 'German',
  fr: 'French',
  es: 'Spanish',
  nl: 'Dutch',
  it: 'Italian',
  cs: 'Czech',
}

export const constants: Constants = {
  socialMediaLinks,
  languages,
} as const
